/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SenderSummary } from './SenderSummary';
import {
    SenderSummaryFromJSON,
    SenderSummaryFromJSONTyped,
    SenderSummaryToJSON,
    SenderSummaryToJSONTyped,
} from './SenderSummary';

/**
 * 
 * @export
 * @interface SenderUpsertResponse
 */
export interface SenderUpsertResponse {
    /**
     * 
     */
    sender: SenderSummary;
}

/**
 * Check if a given object implements the SenderUpsertResponse interface.
 */
export function instanceOfSenderUpsertResponse(value: object): value is SenderUpsertResponse {
    if (!('sender' in value) || value['sender'] === undefined) return false;
    return true;
}

export function SenderUpsertResponseFromJSON(json: any): SenderUpsertResponse {
    return SenderUpsertResponseFromJSONTyped(json, false);
}

export function SenderUpsertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderUpsertResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sender': SenderSummaryFromJSON(json['sender']),
    };
}

export function SenderUpsertResponseToJSON(json: any): SenderUpsertResponse {
    return SenderUpsertResponseToJSONTyped(json, false);
}

export function SenderUpsertResponseToJSONTyped(value?: SenderUpsertResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender': SenderSummaryToJSON(value['sender']),
    };
}

